import { render } from "./ResultatCompositionPage.vue?vue&type=template&id=ed02c948&ts=true"
import script from "./ResultatCompositionPage.vue?vue&type=script&lang=ts"
export * from "./ResultatCompositionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__